/**
 * Angular library starter.
 * Build an Angular library compatible with AoT compilation & Tree shaking.
 * Written by Roberto Simonetti.
 * MIT license.
 * https://github.com/svatrege/gitProjectList
 */

/**
 * Entry point for all public APIs of the package.
 */
export {GitProjectListComponent,IOptions,GitProjectListModule,SearchProjectsService} from './src/gitProjectList';
